<h5>

  <label class="badge badge-secondary" *ngIf="utils.isNumberGt0(contratMenuConvive?.id)">
    <i class="fas fa-handshake site-secondaire-color mg-r-5"></i>
    {{contratMenuConvive.contratMenuLibelle | uppercase}} -  {{contratMenuConvive?.libelle | uppercase}}
  </label>
  <label class="badge badge-secondary"
         *ngIf="!utils.isNumberGt0(contratMenuConvive?.convive?.id)">{{contratMenuConvive.contratMenuLibelle | uppercase}}
    - NOUVELLE PRESTATION</label>
</h5>

<yo-dx-tab-menu
  [selectedItem]="selectedTabCmcDx"
  [items]="tabContratMenuConviveDx"
  width="100%"
  marginBottom="14px"
  (itemClick)="goToTabCmc($event)">
</yo-dx-tab-menu>
<p-card>
  <router-outlet></router-outlet>
</p-card>
